var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "24", viewBox: "0 0 18 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.343 0a4 4 0 0 1 2.829 1.172l3.656 3.656A4 4 0 0 1 18 7.657V20a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h6.343zm0 1.5H4a2.5 2.5 0 0 0-2.495 2.336L1.5 4v16a2.5 2.5 0 0 0 2.336 2.495L4 22.5h10a2.5 2.5 0 0 0 2.495-2.336L16.5 20V7.657a2.5 2.5 0 0 0-.598-1.622l-.134-.146-3.657-3.657a2.5 2.5 0 0 0-1.57-.724l-.198-.008zM9 3.75a.75.75 0 0 1 .743.648l.007.102V8a.25.25 0 0 0 .193.243L10 8.25h3.5a.75.75 0 0 1 .102 1.493l-.102.007H10a1.75 1.75 0 0 1-1.744-1.606L8.25 8V4.5A.75.75 0 0 1 9 3.75z", fill: "currentColor" })
  );
});